<template>
  <div class="top-header">
    <div class="header">
      <div class="left-nav">
        <img src="http://anyouyun.cn/officialWeb/v2/index/logo2.png" alt="">
      </div>
      <div class="right-nav">
        <a-menu v-model="current" mode="horizontal" style="font-size: 16px; font-weight: 600;" @click="handleClick">
          <a-menu-item key="/index">首页</a-menu-item>
          <a-sub-menu popupClassName="popupClassName">
            <span slot="title" key="/ayyk" class="submenu-title-wrapper">安友云控</span>
            <a-menu-item key="/ayyk/pageA">人脸识别</a-menu-item>
            <a-menu-item key="/ayyk/pageB">人员管理</a-menu-item>
            <a-menu-item key="/ayyk/pageC">车辆管理</a-menu-item>
            <a-menu-item key="/ayyk/pageD">环境管理</a-menu-item>
            <a-menu-item key="/ayyk/pageE">现场管理</a-menu-item>
          </a-sub-menu>
          <a-menu-item key="/ayyl">安友云联</a-menu-item>
          <a-sub-menu popupClassName="popupClassName">
            <span slot="title" class="submenu-title-wrapper">解决方案</span>
            <a-menu-item key="/jjfa/gcjs">工程建设</a-menu-item>
            <a-menu-item key="/jjfa/yqgk">园区管控</a-menu-item>
          </a-sub-menu>
          <a-menu-item key="/alzs">案例展示</a-menu-item>
          <!-- <a-sub-menu popupClassName="popupClassName">
            <span slot="title" class="submenu-title-wrapper">解决方案</span>
            <a-menu-item key="/enterprise-solution">企业端</a-menu-item>
            <a-menu-item key="/project-solution">项目端</a-menu-item>
            <a-menu-item key="/construction-solution">安全施工</a-menu-item>
            <a-menu-item key="/dangerou-solution">危大工程</a-menu-item>
          </a-sub-menu> -->
          <!-- <a-menu-item key="/product">案例展示</a-menu-item> -->
          <a-menu-item key="/qdjs">渠道建设</a-menu-item>
          <!-- <a-menu-item key="/product6">新闻中心</a-menu-item> -->
          <a-menu-item key="/about">关于我们</a-menu-item>
          <a-menu-item key="/mall">前往商城</a-menu-item>
          <!-- <a-sub-menu popupClassName="popupClassName">
            <span slot="title" class="submenu-title-wrapper">解决方案</span>
            <a-menu-item key="/enterprise-solution">企业端解决方案</a-menu-item>
            <a-menu-item key="/project-solution">项目端解决方案</a-menu-item>
            <a-menu-item key="/construction-solution">安全施工解决方案</a-menu-item>
            <a-menu-item key="/dangerou-solution">危大工程解决方案</a-menu-item>
          </a-sub-menu>
          <a-menu-item key="/product">产品中心</a-menu-item>
          <a-menu-item key="/cases">经典案例</a-menu-item>
          <a-menu-item key="/qypt">区域平台</a-menu-item>
          <a-menu-item key="/about">关于我们</a-menu-item>
          <a-menu-item key="/call">加入我们</a-menu-item> -->
        </a-menu>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data(){
      return {
        current: ['/index'],
      }
    },
    methods: {
      handleClick(e) {
        if(e.key == '/mall') {
          window.open('https://zhuyouda.com/', '_blank')
        }else {
          this.$router.push(e.key)
        }
      }
    },
    watch: {
      $route: {
        handler(newVal, oldVal) {
          window.scrollTo(0, 0)
          this.current = [newVal.path]
        },
      },
    },
  }
</script>

<style lang="less" scope>
.top-header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99;
  background-color: #fff;
  .header {
    height: 64px;
    display: flex;
    align-items: center;
    .left-nav {
      display: flex;
      align-items: center;
      padding: 0 150px 0 250px;
      img {
        width: 190px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>